<template>
    <div class="main">
        <div style="height:45px"></div>
        <my_menu2 page_name="项目市占率看板" back_type="close" back_icon="md-close"></my_menu2>

        <div>
            <Spin fix v-if="loading">
                <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                <div>玩命加载中</div>
            </Spin>
            <div>
                <Tabs type="card" v-model="dep_1" @on-click="dep_click_1">
                    <TabPane :name="item.value" :label="item.label" v-for="(item, i) in dep_list" :key="i">
                        <div class="tabs_dep">
                            <Tabs v-model="dep_2" @on-click="dep_click_2">
                                <TabPane :name="dep_item.value" :label="dep_item.label"
                                    v-for="(dep_item, dep_index) in item.children" :key="dep_index"></TabPane>
                            </Tabs>
                        </div>
                    </TabPane>
                </Tabs>
                <!-- <span >{{ query_date[0].getMonth() }}{{ query_date[1].getMonth() }}数据跨月，本月数据列已隐藏</span> -->
            </div>
            <div class="table_data">


                <Table size="small" :height="windowHeight - 160" :columns="columns" :data="table_data"></Table>
            </div>
        </div>

    </div>
</template>

<script>
import my_menu2 from "@/component/menu/menu2.vue";
import { http, download_file } from "@/utils/http.js";

export default {
    components: {
        my_menu2,
    },
    data() {


        return {
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度

            //部门数据
            dep_list: [],
            dep_1: '',
            dep_2: '',

            loading: false,
            table_data: [],
            columns: []
        }
    },
    mounted() {
        this.get_dep_options();
    },
    methods: {
        //获取表格数据
        get_table_data() {
            var that = this;
            this.loading = true;
            var obj = {
                dep_id_1: this.dep_1,
                dep_id_2: this.dep_2
            };
            http("post", process.env.VUE_APP_HOST + "/data_panel/project/market_share_table_data", obj, true)
                .then((res) => {
                    if (res.code == 0) {
                        that.columns = res.data.columns;
                        that.table_data = res.data.table_data;
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                    this.loading = false;
                })
                .catch((res) => {
                    this.loading = false;
                    console.log(res, "请求出错");
                });
        },

        dep_click_2(e) {
            console.log('点击小类', e)
            this.dep_2 = e
            this.get_table_data();
        },
        dep_click_1(e) {
            console.log('点击大类', e)
            this.dep_1 = e;
            for (let i = 0; i < this.dep_list.length; i++) {
                var dep_id = this.dep_list[i]["value"];
                if (dep_id == e) {
                    this.dep_2 = this.dep_list[i]["children"][0]["value"];
                    console.log(this.dep_2);
                    this.get_table_data()
                    return;
                }
            }
        },
        get_dep_options() {
            var that = this;
            var obj = {};
            http(
                "post",
                process.env.VUE_APP_HOST + "/data_panel/project/market_share_dep_options",
                obj,
                true
            )
                .then((res) => {
                    if (res.code == 0) {
                        that.dep_list = res.data.data_list;

                        this.dep_1 = that.dep_list[0]["value"];
                        this.dep_2 = that.dep_list[0]["children"][0]["value"];
                        this.get_table_data();

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },
    }
}
</script>

<style scoped>
.demo-spin-col .circular {
    width: 25px;
    height: 25px;
}

.demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
    from {
        transform: rotate(0deg);
    }
    
    50% {
        transform: rotate(180deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.demo-spin-col {
    height: 100px;
    position: relative;
    border: 1px solid #eee;
}

.table_data {
    position: relative;
}

.main {
    background: #f5f7f9;
}
</style>